import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { AccordionComponent } from './accordion.component';
import { AccordionItemDirective } from './directives/accordion-item.directive';
import { AccordionContent } from './directives/accordion-content.directive';
import { AccordionTitle } from './directives/accordion-title.directive';
import { AccordionHeader } from './directives/accordion-header.directive';
import { AccordionHeaderContentDirective } from './directives/accordion-header-content.directive';

@NgModule({
  declarations: [
    AccordionComponent,
    AccordionItemDirective,
    AccordionContent,
    AccordionTitle,
    AccordionHeader,
    AccordionHeaderContentDirective
  ],
  imports: [CommonModule],
  exports: [
    AccordionComponent,
    AccordionItemDirective,
    AccordionContent,
    AccordionTitle,
    AccordionHeader,
    AccordionHeaderContentDirective
  ]
})
export class AccordionModule {}
